import UpsellView from "compid/shared/views/UpsellView";
import React from "react";

/**
 * @function UpselleBillView 
 * @param {OBJECT} props - Default React.Components props OBJECT
 * @returns {React.Component}
 * @example
 * <UpselleBillView />
 */

export default function UpselleBillView(props) {
  return (
    <UpsellView 
      text="Get your electronic statements and payment reminders here with eBills."
      textClass="blue-text"
      onClick={ props.onClick }
      biller={ props.biller }
      dataPoint={ props.dataPoint } />
  ) 
}
